import styled, { css } from 'styled-components';
import type { LabelStyledProps } from './Label.types';

const RequiredIndicator = styled.span`
  margin-left: 1px;
  color: ${({ theme }) => theme.brand.secondary.dark};
`;

const Label = styled.label<LabelStyledProps>(({ color }) => {
  return css`
    font-size: ${({ theme }) => theme.typography.fontSizes.B16};
    line-height: ${({ theme }) => theme.typography.lineHeights.M24};
    color: ${({ theme }) => color || theme.brand.secondary.dark};
  `;
});

export { Label, RequiredIndicator };
